import React from 'react';
import './Plans.css';
import { CheckIcon, PhoneIcon } from './icons/ServiceIcons';
import { useLanguage } from '../contexts/LanguageContext';

const Plans = () => {
  const { t, localizedPath } = useLanguage();

  const plans = [
    {
      title: t('plans.projectBased.title'),
      subtitle: t('plans.projectBased.subtitle'),
      features: [
        t('plans.projectBased.description1'),
        t('plans.projectBased.description2'),
        t('plans.projectBased.description3')
      ],
      includes: [
        t('plans.projectBased.features.team'),
        t('plans.projectBased.features.manager'),
        t('plans.projectBased.features.qa'),
        t('plans.projectBased.features.documentation'),
        t('plans.projectBased.features.support')
      ],
      highlighted: false
    },
    {
      title: t('plans.dedicatedTeam.title'),
      subtitle: t('plans.dedicatedTeam.subtitle'),
      features: [
        t('plans.dedicatedTeam.description1'),
        t('plans.dedicatedTeam.description2'),
        t('plans.dedicatedTeam.description3')
      ],
      includes: [
        t('plans.dedicatedTeam.features.developers'),
        t('plans.dedicatedTeam.features.devops'),
        t('plans.dedicatedTeam.features.qa'),
        t('plans.dedicatedTeam.features.lead'),
        t('plans.dedicatedTeam.features.support')
      ],
      highlighted: true,
      popular: t('plans.dedicatedTeam.popular')
    },
    {
      title: t('plans.managedServices.title'),
      subtitle: t('plans.managedServices.subtitle'),
      features: [
        t('plans.managedServices.description1'),
        t('plans.managedServices.description2'),
        t('plans.managedServices.description3')
      ],
      customTitle: t('plans.managedServices.managementTitle'),
      includes: [
        t('plans.managedServices.features.monitoring'),
        t('plans.managedServices.features.security'),
        t('plans.managedServices.features.backup'),
        t('plans.managedServices.features.optimization'),
        t('plans.managedServices.features.maintenance')
      ],
      highlighted: false
    }
  ];

  return (
    <section id="plans" className="plans section">
      <div className="container">
        <h2 className="section-title">{t('plans.title')}</h2>
        <div className="plans-grid">
          {plans.map((plan, index) => (
            <div key={index} className={`plan-card ${plan.highlighted ? 'highlighted' : ''}`}>
              <div className="plan-header">
                <h3 className="plan-title">{plan.title}</h3>
                <span className="plan-subtitle">{plan.subtitle}</span>
                {plan.popular && (
                  <span className="popular-badge">{plan.popular}</span>
                )}
              </div>
              
              <div className="plan-features">
                {plan.features.map((feature, idx) => (
                  <p key={idx} className="plan-feature">{feature}</p>
                ))}
              </div>
              
              <div className="plan-includes">
                {plan.customTitle && (
                  <h4 className="includes-title">{plan.customTitle}</h4>
                )}
                <ul className="includes-list">
                  {plan.includes.map((item, idx) => (
                    <li key={idx} className="include-item">
                      <span className="include-icon"><CheckIcon size={16} /></span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              
              <a href={localizedPath('/contact')} className="btn-primary plan-cta">
                {t('plans.contactUs')}
                <span className="btn-icon"><PhoneIcon size={18} /></span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Plans;
